module.exports = __webpack_public_path__ + "static/media/Shruti_Ravichandran.2085597f.jpg";